"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
exports.default = lodash_1.curry(function (subject, course) {
    return course.subject_area_code + "" === subject.id + "";
});
//# sourceMappingURL=courseIsSubjectArea.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/utils/courseIsSubjectArea.js
// module id = 462
// module chunks = 22